module.exports = __webpack_public_path__ + "img/Kultapossu-Mestari.cadff7ac.png";